import axios from "axios";
import { servicePath } from "../../utility/data";

  export const getGroupsServices = async (accessToken) => {
  
    try {
      const response = await axios.get(`${servicePath}/groups`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      // console.error('Error:', error);
      throw error;
    }
  };


  export const addGroup = async (name ,status, accessToken) => {
    const payload = {
    "name": name,
    "status": status,
    };
  
    try {
      const response = await axios.post(`${servicePath}/groups`, payload, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      // console.error('Error :', error);
      throw error;
    }
  };

  export const updateGroup = async (name ,status, group_id, accessToken) => {
    const payload = {
    "name": name,
    "status": status,
    };
  
    try {
      const response = await axios.put(`${servicePath}/groups/${group_id}`, payload, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      // console.error(error);
      throw error;
    }
  };


  export const deleteGroups = async (accessToken, id) => {
  
    try {
      const response = await axios.delete(`${servicePath}/groups/${id}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      // console.error('Error during user registration:', error);
      throw error;
    }
  };